// src/pages/admin/AdminHome.js
import React from 'react';
import {
  Container, Typography, Grid, Card, CardActionArea,
  CardContent, Box
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import InventoryIcon from '@mui/icons-material/Inventory';
import CategoryIcon from '@mui/icons-material/Category';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import ListAltIcon from '@mui/icons-material/ListAlt';

const tiles = [
  {
    title: 'Ürünler',
    description: 'Ürün ekle, düzenle, fotoğraf ve uyumluluk yönet',
    icon: <InventoryIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
    path: '/admin/products',
  },
  {
    title: 'Ürün Tipleri',
    description: 'Ana kategorileri yönet',
    icon: <CategoryIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
    path: '/admin/producttypes',
  },
  {
    title: 'Ürün Alt Tipleri',
    description: 'Alt kategorileri yönet',
    icon: <ListAltIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
    path: '/admin/productsubtypes',
  },
  {
    title: 'Araç Markaları',
    description: 'Renault, Dacia vb. markaları yönet',
    icon: <DirectionsCarIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
    path: '/admin/vehicles/brands',
  },
  {
    title: 'Araç Modelleri',
    description: 'Clio, Duster vb. modelleri yönet',
    icon: <DirectionsCarIcon sx={{ fontSize: 48, color: 'secondary.main' }} />,
    path: '/admin/vehicles/models',
  },
  {
    title: 'Araç Serileri',
    description: 'Nesil ve yıl aralıklarını yönet',
    icon: <DirectionsCarIcon sx={{ fontSize: 48, color: 'text.secondary' }} />,
    path: '/admin/vehicles/series',
  },
];

const AdminHome = () => {
  const navigate = useNavigate();

  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Admin Dashboard
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Yönetmek istediğiniz bölümü seçin.
      </Typography>

      <Grid container spacing={3}>
        {tiles.map((tile) => (
          <Grid item xs={12} sm={6} md={4} key={tile.path}>
            <Card variant="outlined" sx={{ height: '100%', '&:hover': { borderColor: 'primary.main' } }}>
              <CardActionArea onClick={() => navigate(tile.path)} sx={{ p: 2, height: '100%' }}>
                <CardContent>
                  <Box sx={{ mb: 1 }}>{tile.icon}</Box>
                  <Typography variant="h6" fontWeight={600}>
                    {tile.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                    {tile.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default AdminHome;
